import { PRODUCT_CATALOGUE_UUID } from "../providers/PriceListProvider";
export function getProductTitle(orderLine, t) {
    if (orderLine.product.type == 200) {
        return orderLine.description;
    }
    else if (orderLine.product.uuid == PRODUCT_CATALOGUE_UUID) {
        return t("Catalogue");
    }
    return orderLine.product.name;
}
